import { render, staticRenderFns } from "./activity-form.vue?vue&type=template&id=23fcb3c6"
import script from "./activity-form.vue?vue&type=script&lang=js"
export * from "./activity-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports